module.exports={
  "Show menu": "Vis menu",
  "Menu": "Menu",
  "Hide menu": "Skjul menu",
  "Close": "Luk",
  "Turn off high contrast": "Deaktiver hÃ¸j kontrast",
  "Turn on high contrast": "AktivÃ©r hÃ¸j kontrast"
}
